/*
 * gatsby-browser.js
 * -----------------
 * This file is imported by the Gatsby entry level script. You should use this
 * file to include global imports, such global styles.
 */

import "./src/styles/index.scss";
import React from "react";
import { IntlProvider } from "./src/components/IntlProvider";
import { getLangForPagePath } from "./src/utils/getLangForPagePath";
import { getPageLangVariantsForPagePath } from "./src/utils/getPageLangVariantsForPagePath";

export const wrapRootElement = ({ element }) => (
  <IntlProvider
    initialLang={getLangForPagePath(window.location.pathname)}
    initialPageLangVariants={getPageLangVariantsForPagePath(
      window.location.pathname,
    )}
  >
    {element}
  </IntlProvider>
);
